import PropTypes from 'prop-types';

import cx from 'classnames';

import isNotEmptyReactElementContent from 'core/utils/content';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';

import withBreakpoint from 'core/hocs/withBreakpoint';
import withTheme from 'core/hocs/withTheme';
import H4 from 'core/components/H4';
import Scroller from 'core/components/Scroller';
import EmptyWrapper from 'core/components/EmptyWrapper';

const columnWidth = columnCount => {
  return columnCount ? 100 / columnCount : null;
};

/**
 * @author Alexey Rezakov <a.rezakov@rambler-co.ru>
 */
function Tags({
  title,
  headerComponent: HeaderComponent,
  titleWrap,
  titleGap,
  breakpoint,
  columnCount,
  verticalSpacing,
  horizontalSpacing,
  isDesktop,
  isMobile,
  children,
  dataQa,
  theme,
}) {
  const childrenArr = [].concat(children).filter(isNotEmptyReactElementContent);

  // TODO: REF Отрефакторить компонент (в частности название перменных)
  const restSize = (columnCount - childrenArr.length % columnCount) * columnWidth(columnCount);
  const descol = isDesktop && columnWidth(columnCount);

  const halfVer = verticalSpacing / 2;
  const halfHor = horizontalSpacing / 2;

  const Wrapper = isDesktop ? EmptyWrapper : Scroller;

  const {
    controls: {
      tags: {
        margin,
        padding,
      },
    },
  } = theme;

  return (
    <div
      className={cx(
        'tags',
        (isMobile || titleWrap) && 'tags_wrap',
        breakpoint,
      )}
      {...dataQa && { 'data-qa': dataQa }}
    >
      {/* Компонент используется в AMP версии, стили выносить не нужно */}
      <style jsx>{`
        .tags
          display flex
          overflow hidden
          &_wrap
            overflow hidden
            flex-wrap wrap
          :global(.mobile) &
            margin ${margin}
            padding ${padding}

        .title
          flex-shrink 0
          .tags_wrap &
            width 100%

        .list
          display flex
          flex-wrap wrap
          .mobile &
            flex-wrap nowrap
      `}</style>
      <style jsx>{`
        .list
          margin ${descol ? (-halfVer + 'px auto') : (-halfVer + 'px ' + -halfHor + 'px')}
          &:after
            content ${isDesktop && columnCount ? '""' : 'none'}
            flex 1 0 ${restSize + '%'}

        .tag
          flex ${descol ? ('1 0 ' + columnWidth(columnCount) + '%') : 'none'}
          margin ${descol ? (halfVer + 'px auto') : (halfVer + 'px ' + halfHor + 'px')}

        .title
          margin ${halfVer + 'px 0'}
          padding-right ${titleGap}px
      `}</style>
      {isNotEmptyReactElementContent(title) && (
        <div className='title' {...dataQa && { 'data-qa': dataQa + '-title' }}>
          <HeaderComponent>{title}</HeaderComponent>
        </div>
      )}
      <Wrapper>
        <div className='list' {...dataQa && { 'data-qa': dataQa + '-list' }}>
          {childrenArr.map((item, index) => (
            <div className='tag' key={index}
              {...dataQa && { 'data-qa': dataQa + '-item' }}
            >{item}</div>
          ))}
        </div>
      </Wrapper>
    </div>
  );
}

Tags.propTypes = {
  /** @ignore */
  breakpoint: breakpointPropTypes(true),

  /** @ignore */
  isMobile: PropTypes.bool,

  /** @ignore */
  isDesktop: PropTypes.bool.isRequired,

  /**
   * Компонент, в котором будет отрендерен заголовок
   */
  headerComponent: PropTypes.func,

  /**
   * Заголовок
   */
  title: PropTypes.node,

  /**
   * Вертикальный отступ между заголовком и тегами.
   */
  titleGap: PropTypes.number,

  /**
   * Переносить теги на новую строку на десктопе.
   * На мобильной версии теги всегда начинаются с новой строки.
   */
  titleWrap: PropTypes.bool,

  /**
   * Расстояние между горизонтальное
   */
  horizontalSpacing: PropTypes.number,

  /**
   * Расстояние между вертикальное, елси теги расположены на несклько строк
   */
  verticalSpacing: PropTypes.number,

  /**
   * Позволяет выстроить теги в моноширинные блоки, для десктоп разрешения
   */
  columnCount: PropTypes.number,

  /**
   *  Разметка для автотестов UI
   */
  dataQa: PropTypes.string,

  /** @ignore */
  theme: PropTypes.object,
};

Tags.defaultProps = {
  headerComponent: H4,
  titleWrap: false,
  titleGap: 20,
  verticalSpacing: 10,
  horizontalSpacing: 10,
};

const TagsWithHOCs = withTheme(withBreakpoint(Tags));
TagsWithHOCs.displayName = 'Tags';

export { Tags as StorybookComponent };
export default TagsWithHOCs;
